import { useDrawerStore } from '@nexelem/drawer';
import { Button } from '@nexelem/components';
import { useFiltersContext } from '../hooks';
import clsx from 'clsx';

type FiltersClearButtonProps = {
  label: string;
  onClick?: () => void;
};

export const FiltersClearButton = ({ label, onClick }: FiltersClearButtonProps) => {
  const closeRightDrawer = useDrawerStore((state) => state.onCloseRightDrawer);
  const { hasFiltersSelected, onResetFilters } = useFiltersContext();

  const internalOnClick = () => {
    onResetFilters();
    onClick?.();
    closeRightDrawer();
  };
  return (
    <Button className={clsx(!hasFiltersSelected && 'invisible')} variant="text" onClick={internalOnClick}>
      {label}
    </Button>
  );
};
